<template>
	<div>
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="所属门店：">
				<el-select filterable v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" @change="GetPayHistoryMonthStatistic">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="日期：">
				<el-date-picker
					v-model="inputDate"
					type="month"
					:default-value="new Date()"
					:clearable="false"
					value-format="yyyy-MM"
					placeholder="选择日期"
					:editable="false"
					format="yyyy年MM月"
					size="small"
					@change="changeDate"
				></el-date-picker>
			</el-form-item>
			<el-form-item style="float: right">
				<el-radio-group v-model="viewMode" size="small" style="margin-right: 10px" @input="changeViewMode">
					<el-radio-button label="chart">图表</el-radio-button>
					<el-radio-button label="list">列表</el-radio-button>
				</el-radio-group>
				<el-radio-group v-if="viewMode === 'chart'" v-model="echartType" border @input="changeChartType">
					<el-radio-button label="category">柱状图</el-radio-button>
					<el-radio-button label="line">折线图</el-radio-button>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<div v-show="viewMode === 'chart'" class="statisticChart"></div>
		<div v-show="viewMode === 'list'" class="statisticList">
			<div class="listTitle">{{ title }}</div>
			<el-table :cell-class-name="$moneyCellClass" v-loading="loading" :data="tableData" border stripe height="560" :row-class-name="tableRowClassName">
				<el-table-column prop="rowNumber" label="序号" align="center" width="70">
					<template #default="scope">
						{{ scope.row.isTotal ? "" : scope.row.rowNumber }}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="日期" align="center" min-width="120" />
				<el-table-column v-for="(typeName, index) in payTypeNameList" :key="index" :prop="typeName" :label="typeName" align="center" min-width="130">
					<template #default="scope">
						<span style="color: #07c160; font-weight: 600; white-space: nowrap">{{ formatMoney(scope.row[typeName]) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="total" label="合计" align="center" min-width="140">
					<template #default="scope">
						<span style="color: #f56c6c; font-weight: bold; white-space: nowrap">{{ formatMoney(scope.row.total) }}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import { GetPayHistoryMonthStatistic } from "@/api/payApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import * as echarts from "echarts";
export default {
	data() {
		return {
			loading: false,
			statisticData: {
				xnameList: []
			},
			formInline: {
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1,
				storeKeyId: ""
			},
			title: "门店收款统计",
			echartType: "category",
			viewMode: "list",
			tableData: [],
			inputDate: new Date(),
			payTypeNameList: [],
			seriesList: [],
			storeList: []
		};
	},
	components: {},

	created() {
		this.GetEnumConfigListByCode();
		this.GetOrgInfoListByConfig();
		// Then load data
		this.GetPayHistoryMonthStatistic(this.formInline);
	},

	mounted() {
		// First initialize the chart with proper sequence
		this.initChart();
	},

	methods: {
		// 格式化金额
		formatMoney(val) {
			const num = parseFloat(val) || 0;
			return "￥" + num.toFixed(2) + " 元";
		},
		// 合计行高亮
		tableRowClassName({ row }) {
			return row.isTotal ? "total-row" : "";
		},
		// 切换视图：切回图表时确保图表已初始化并按当前尺寸重绘
		changeViewMode(mode) {
			if (mode === "chart") {
				this.$nextTick(() => {
					if (!this.chart || this.chart.isDisposed()) {
						this.initChart();
					}
					this.changeChartType();
					if (this.chart && !this.chart.isDisposed()) {
						this.chart.resize();
					}
				});
			}
		},
		// Switch chart type between bar and line
		changeChartType() {
			// Check if chart instance exists before operating
			if (!this.chart || this.chart.isDisposed()) {
				// If not, get container and create new instance
				const chartDom = document.querySelector(".statisticChart");
				if (chartDom) {
					this.chart = echarts.init(chartDom);
				} else {
					console.error("Chart container not found");
					return;
				}
			}

			// 根据图表类型设置配置
			const isBarChart = this.echartType === "category";
			const chartTitle = this.title + (isBarChart ? "柱状图" : "折线图");
			const chartType = isBarChart ? "bar" : "line";
			const axisPointerType = isBarChart ? "shadow" : "line";

			// 更新seriesList中每个系列的type和样式属性
			const updatedSeriesList = this.seriesList.map((series) => {
				const baseConfig = {
					...series,
					type: chartType,
					smooth: !isBarChart, // 只有折线图需要平滑
					symbol: !isBarChart ? "circle" : undefined, // 只有折线图需要数据标记
					symbolSize: !isBarChart ? 6 : undefined // 设置折线图的数据标记大小
				};

				// 如果是柱状图，添加label配置显示顶部数值
				if (isBarChart) {
					baseConfig.label = {
						show: true,
						position: "top",
						formatter: "{c} 元",
						fontSize: 10,
						color: "#333"
					};
				}

				return baseConfig;
			});

			// 设置图表选项
			const option = {
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: axisPointerType
					},
					// 格式化提示框显示金额
					formatter: function (params) {
						let result = params[0].name + "<br/>";
						params.forEach((param) => {
							result += param.marker + param.seriesName + ": " + param.value + " 元<br/>";
						});
						return result;
					}
				},
				title: {
					text: chartTitle,
					left: "center",
					textStyle: {
						color: "#333",
						fontSize: 18
					},
					// 调整标题位置，为legend留出空间
					top: "10px"
				},
				// 添加legend组件，允许用户选择显示哪些数据系列
				legend: {
					data: this.payTypeNameList,
					// 水平居中显示在标题下方
					top: "40px",
					left: "center",
					// 设置选中和未选中的样式
					textStyle: {
						color: "#666"
					},
					// 允许多选，但通过事件处理确保至少保留一个选中项
					selectedMode: "multiple"
				},
				grid: {
					left: "2%",
					right: "5%",
					bottom: "2%",
					// 为legend留出顶部空间
					top: "100px",
					containLabel: true
				},
				xAxis: {
					name: "日期",
					type: "category",
					data: this.statisticData.xnameList,
					axisLabel: {
						interval: 0,
						rotate: 30
					}
				},
				yAxis: {
					type: "value",
					name: "金额",
					// 设置y轴标签格式化，显示货币符号
					axisLabel: {
						formatter: "{value} 元"
					}
				},
				series: updatedSeriesList
			};

			try {
				// 设置图表选项 with null check
				if (this.chart && !this.chart.isDisposed()) {
					this.chart.setOption(option);
				}
			} catch (error) {
				console.error("Error setting chart option:", error);
			}
		},
		// Initialize chart and set up event listeners
		initChart() {
			// Get chart container
			const chartDom = document.querySelector(".statisticChart");
			if (chartDom) {
				// Initialize echarts instance
				this.chart = echarts.init(chartDom);
				// Set up resize listener with null check
				window.addEventListener("resize", () => {
					if (this.chart && !this.chart.isDisposed()) {
						this.chart.resize();
					}
				});

				// 添加legend选择事件监听器，确保至少保留一个选中项
				this.chart.on("legendselectchanged", (params) => {
					const selected = params.selected;
					let selectedCount = 0;
					let lastSelectedName = null;

					// 统计选中的数量并记录最后一个选中项
					for (const name in selected) {
						if (selected[name]) {
							selectedCount++;
							lastSelectedName = name;
						}
					}

					// 如果尝试取消所有选中项，强制保持最后一个选中
					if (selectedCount === 0 && lastSelectedName) {
						this.chart.dispatchAction({
							type: "legendSelect",
							name: lastSelectedName
						});
					}
				});
			}
		},
		//获取统计数据
		GetPayHistoryMonthStatistic() {
			GetPayHistoryMonthStatistic(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						if (res.data) {
							this.title = res.data.title;
							this.statisticData.xnameList = [];
							this.seriesList = [];
							this.payTypeNameList = [];

							// 收集所有的日期名称
							res.data.items.forEach((item) => {
								this.statisticData.xnameList.push(item.name);
							});

							// 收集所有不同的支付类型名称
							const payTypeNames = new Set();
							res.data.items.forEach((item) => {
								if (item.payList && Array.isArray(item.payList)) {
									item.payList.forEach((payItem) => {
										if (payItem.payTypeName) {
											payTypeNames.add(payItem.payTypeName);
										}
									});
								}
							});

							// 将Set转换为数组并赋值给payTypeNameList
							this.payTypeNameList = Array.from(payTypeNames);

							// 为每个支付类型创建一个series对象
							this.payTypeNameList.forEach((typeName) => {
								// 创建包含所有日期点的data数组，初始值为0
								const seriesData = [];

								// 遍历每个日期项，查找对应的支付类型数据
								res.data.items.forEach((item) => {
									let found = false;
									if (item.payList && Array.isArray(item.payList)) {
										// 在当前日期的payList中查找匹配的支付类型
										for (let i = 0; i < item.payList.length; i++) {
											const payItem = item.payList[i];
											if (payItem.payTypeName === typeName) {
												// 找到匹配项，添加金额
												seriesData.push(parseFloat(payItem.payMoney) || 0);
												found = true;
												break;
											}
										}
									}
									// 如果没找到匹配项，添加0
									if (!found) {
										seriesData.push(0);
									}
								});

								// 创建series对象并添加到seriesList
								this.seriesList.push({
									name: typeName,
									type: this.echartType === "category" ? "bar" : "line",
									data: seriesData,
									// 为折线图添加平滑效果和数据标记
									smooth: this.echartType === "line",
									symbol: this.echartType === "line" ? "circle" : undefined,
									symbolSize: this.echartType === "line" ? 6 : undefined
								});
							});

							// 构建列表（表格）数据：每行一个日期，列为各支付类型金额
							// 后台已在 items 末尾返回“合计”行，前端直接展示，不再自行汇总
							let seq = 0;
							this.tableData = res.data.items.map((item) => {
								const isTotal = item.name === "合计";
								const row = {
									name: item.name,
									isTotal: isTotal,
									rowNumber: isTotal ? "" : ++seq,
									total: 0
								};
								this.payTypeNameList.forEach((typeName) => {
									row[typeName] = 0;
								});
								if (item.payList && Array.isArray(item.payList)) {
									item.payList.forEach((payItem) => {
										const money = parseFloat(payItem.payMoney) || 0;
										if (payItem.payTypeName) {
											row[payItem.payTypeName] = (row[payItem.payTypeName] || 0) + money;
										}
										row.total += money;
									});
								}
								return row;
							});

							// 数据更新后刷新图表 with proper check
							if (this.chart && !this.chart.isDisposed()) {
								// 调用changeChartType方法重新渲染整个图表，确保图表类型、标题等配置也能正确更新
								this.changeChartType();
							} else if (!this.chart) {
								// If chart instance doesn't exist, create one first
								this.initChart();
								this.changeChartType();
							}
						}
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 时间选择
		changeDate(val) {
			if (val) {
				this.formInline.year = parseInt(val.split("-")[0]);
				this.formInline.month = parseInt(val.split("-")[1]);
			}
			this.GetPayHistoryMonthStatistic();
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "PayType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.payTypeNameList = [];
						res.data.forEach((item) => {
							this.payTypeNameList.push(item.name);
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		}
	}
};
</script>

<style scoped lang="scss">
.work_title_color {
	width: 5px;
	height: 20px;
	background-color: #409eff;
	display: inline-block;
	padding: 0;
	margin: 0;
}

.work_title {
	font-size: 16px;
	font-weight: 700;
	font-family: 微软雅黑;
	padding: 0;
	margin: 0;
	margin-left: 10px;
	display: inline-block;
}

.statisticChart {
	width: 100%;
	height: 600px;
	margin-top: 10px;
	padding-top: 20px;
	background-color: #fff;
	border-radius: 10px;
}

.statisticList {
	width: 100%;
	margin-top: 10px;
	padding: 20px;
	background-color: #fff;
	border-radius: 10px;
	box-sizing: border-box;
}

.listTitle {
	text-align: center;
	font-size: 18px;
	color: #333;
	font-weight: 700;
	margin-bottom: 16px;
}

.statisticList ::v-deep .total-row {
	background-color: #fdf6ec;
	font-weight: bold;
}

.statisticList ::v-deep .total-row td {
	color: #e6a23c;
}
</style>
